import { HIVE_TOOLBAR_WIDGET, HiveToolbarWidget } from './toolbar';

export function effects() {
  customElements.define(HIVE_TOOLBAR_WIDGET, HiveToolbarWidget);
}

declare global {
  interface HTMLElementTagNameMap {
    [HIVE_TOOLBAR_WIDGET]: HiveToolbarWidget;
  }
}
